export default "__VITE_ASSET__b25ed24b__"